/**
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-04-02 09:18:20
 * @LastEditTime: 2021-04-15 15:56:52
 * @FilePath: \buyer-one\dop-webapp\src\init.js
 * @Copyright: Copyright 2021-2021, all rights reserved. Essa.cn
 */
import Locale from "./utils/locale";
import Cookie from "./utils/cookie";

/**
 * 页面语言
 */
Locale.init("fmg.lang");

/**
 * 数据语言
 */
let extra = Cookie.getJSON("fmg.extra") || {};
extra.lang = Locale.current();
Cookie.set("fmg.extra", extra);

/**
 * 全局处理JQuery Ajax的公共请求参数。此处采用重写jQuey核心方法的方式
 * 实属无奈，等以后有更好方案再优化。
 */
let oldAjax = $.ajax;
$.ajax = function (url, options) {
    // If url is an object, simulate pre-1.5 signature
    if (typeof url === "object") {
        options = url;
        url = undefined;
    }
    // Force options to be an object
    options = options || {};
    // Custom Data
    if (options && options.data) {
        let extra = Cookie.getJSON("fmg.extra");
        if (extra) {
            // 实时获取当前浏览器的语言设定
            extra.lang = Locale.current();
            extra.businessPlatform = 'essaone';
        }
        let jsonData = JSON.parse(options.data);
        jsonData.extra = extra;
        options.data = JSON.stringify(jsonData);
    }
    // Return
    return oldAjax(url, options);
};
